import Vue from "vue";
import store from "./store";
import App from "./App.vue";
import createPersistedState from "vuex-persistedstate";
import Vuex from "vuex";
import Axios from "axios";

import router from "./router";
import Shared from "@/mixins/Shared.js";

import "@/components/_globals";

Vue.config.productionTip = false;
window.axios = require("axios");
Vue.prototype.$http = Axios;

Vue.use(createPersistedState);
Vue.use(Vuex);

export default {
  mixins: [Shared]
};

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");

window.onbeforeunload = function() {
  // websocket.close();
};
